import { render, staticRenderFns } from "./matter_warehouse.vue?vue&type=template&id=7a70fe34&scoped=true&"
import script from "./matter_warehouse.vue?vue&type=script&lang=js&"
export * from "./matter_warehouse.vue?vue&type=script&lang=js&"
import style0 from "./matter_warehouse.vue?vue&type=style&index=0&id=7a70fe34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70fe34",
  null
  
)

export default component.exports